var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "md-field",
    { staticClass: "md-chips", class: [_vm.$mdActiveTheme, _vm.chipsClasses] },
    [
      _vm._t("default"),
      _vm._v(" "),
      _vm._l(_vm.value, function (chip, key) {
        return _c(
          "md-chip",
          {
            key: chip,
            attrs: {
              "md-deletable": !_vm.mdStatic,
              "md-clickable": !_vm.mdStatic,
              "md-duplicated": _vm.duplicatedChip === chip,
            },
            on: {
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.$emit("md-click", chip, key)
              },
              "md-delete": function ($event) {
                $event.stopPropagation()
                return _vm.removeChip(chip)
              },
            },
            nativeOn: {
              click: function ($event) {
                return _vm.$emit("md-click", chip, key)
              },
            },
          },
          [
            _vm.$scopedSlots["md-chip"]
              ? _vm._t(
                  "md-chip",
                  function () {
                    return [_vm._v(_vm._s(chip))]
                  },
                  { chip: chip }
                )
              : [_vm._v(_vm._s(chip))],
          ],
          2
        )
      }),
      _vm._v(" "),
      !_vm.mdStatic && _vm.modelRespectLimit
        ? _c("md-input", {
            ref: "input",
            attrs: {
              type: _vm.mdInputType,
              id: _vm.id,
              placeholder: _vm.mdPlaceholder,
            },
            on: {
              input: _vm.handleInput,
              keydown: [
                function ($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                  )
                    return null
                  return _vm.insertChip.apply(null, arguments)
                },
                function ($event) {
                  if (!$event.type.indexOf("key") && $event.keyCode !== 8)
                    return null
                  return _vm.handleBackRemove.apply(null, arguments)
                },
              ],
              focusout: _vm.handleFocusOut,
            },
            model: {
              value: _vm.inputValue,
              callback: function ($$v) {
                _vm.inputValue = typeof $$v === "string" ? $$v.trim() : $$v
              },
              expression: "inputValue",
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }